module.exports = {"version":2,"waiters":{"ResourceRecordSetsChanged":{"delay":30,"maxAttempts":60,"operation":"GetChange","acceptors":[{"matcher":"path","expected":"INSYNC","argument":"ChangeInfo.Status","state":"success"}]}}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/route53-2013-04-01.waiters2.json
// module id = 599
// module chunks = 30